import { useState } from 'react';

export function useDialog<T = boolean>() {
  const [resolvePromise, setResolvePromise] = useState<(value: T | PromiseLike<T>) => void>();
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [isDialogLoading, setDialogLoading] = useState(false);
  const openDialog = () => {
    return new Promise<T>((resolve) => {
      setResolvePromise(() => resolve);
      setDialogIsOpen(true);
    });
  };
  const closeDialog = (value?: T) => {
    setDialogIsOpen(false);
    if (value) {
      resolvePromise?.(value);
    } else {
      resolvePromise?.(false as unknown as T);
    }
    setResolvePromise(undefined);
  };

  return {
    dialogIsOpen,
    openDialog,
    isDialogLoading,
    setDialogLoading,
    closeDialog,
  };
}
